import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { tokenStore } from "../lib/api";

export async function downloadPdf(url, filename) {
  // url is absolute; uses Bearer token via fetch since <a href> can't send headers
  const token = tokenStore.get();
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(`Failed to download: ${res.status}`);
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}
